import { createEnum } from './helpers'

/* Status */

export const ACTIVE_STATUS_VALUES = ['active'] as const

export type ActiveStatusOption = (typeof ACTIVE_STATUS_VALUES)[number]

/* Update errors */

export const LAUNCH_UPDATE_ERRORS = ['launchNameConflict'] as const

export const LAUNCH_UPDATE_ERROR_TYPES = createEnum(LAUNCH_UPDATE_ERRORS)
export type LaunchUpdateErrorType = (typeof LAUNCH_UPDATE_ERRORS)[number]
